<template>
    <div class="opui-item op-flow-type-trigger">
        <div class="opui-left" @click.prevent="$emit('edit', item)">
            <a class="op-flow-icon" href="#">
                <span v-html="item.icon"></span>
            </a>
            <div class="opui-title">
                <p><a href="#">{{ item.description }}</a></p>
                <h3><a href="#">{{ item.title }}</a></h3>
            </div>
        </div>
        <div class="op-flow-actions">
            <a href="#" @click.prevent="$emit('delete', item)" class="op-flow-action">
                <i class="opui-icon-trash"></i>
                {{ $e('Delete') }}
            </a>
            <a href="#" @click.prevent="$emit('edit', item)" class="op-flow-action">
                <i class="opui-fa opui-fa-cog"></i>
                {{ $e('Edit') }}
            </a>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        item:     { type: Object, required: true },
        workflow: { type: Object, required: true },
    },
}
</script>
